import { TooltipIcon } from "./index";

const RlAuxiliaryAnalysisInfoTooltip = () => (
  <TooltipIcon
    icon="info-circle"
    message={
      "Enriching static analysis using 3rd party scripts with additional metadata."
    }
    className="label-tooltip-icon"
  />
);

export default RlAuxiliaryAnalysisInfoTooltip;
